<template>
  <div style="height:100%;background:#fff;border-radius:4px;padding:24px">
    <div>
      <span style="color:rgba(18, 18, 18, 1);font-size:16px;font-weight:bold;">报备管理</span>
      <div style="display:inline-block;float:right">
        <!-- <span style="display: inline-block;width:88px;height:32px;line-height: 32px;text-align: center;cursor: pointer;background:rgba(66, 223, 228, 1);border-radius: 4px;font-size:14px;color:#fff;;">新建报备</span> -->
        <a-dropdown :trigger="['click']">
          <a-button type="primary">新建报备</a-button>
          <a-menu slot="overlay" style="text-align:center">
            <a-menu-item key="1" @click="reportSign()">
              <div style="color:rgba(80, 80, 80, 1);font-size:14px;">报备签名</div>
              <div style="color:rgba(188, 188, 188, 1);font-size:12px;">（需选择模板）</div>
            </a-menu-item>
            <a-menu-divider />
            <a-menu-item key="2" @click="reportDomainName(3)">
              <div style="color:rgba(80, 80, 80, 1);font-size:14px;">报备域名</div>
              <div style="color:rgba(188, 188, 188, 1);font-size:12px;">（仅发送移动）</div>
            </a-menu-item>
            <a-menu-divider />
            <a-menu-item key="3" @click="reportPhone(2)">
              <div style="color:rgba(80, 80, 80, 1);font-size:14px;">报备联系电话</div>
              <div style="color:rgba(188, 188, 188, 1);font-size:12px;">（仅发送移动）</div>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </div>
    </div>
    <div style="margin-top:20px;">
      <a-radio-group name="select" :default-value="1" @change="changeSelect" v-model="reportShare" style="margin-right:120px;">
        <a-radio :value="1">
          私有
        </a-radio>
        <a-radio :value="2">
          共享
        </a-radio>
      </a-radio-group>

      <a-radio-group name="select" :default-value="0" @change="changeReportType" v-model="reportType">
        <a-radio :value="0">
          全部
        </a-radio>
        <a-radio :value="1">
          签名
        </a-radio>
        <a-radio :value="2">
          联系电话
        </a-radio>
        <a-radio :value="3">
          引流域名
        </a-radio>
      </a-radio-group>
    </div>
    <div style="margin-top:24px;">
      <a-table
        :data-source="sendMsgRecord"
        :pagination="false"
        :scroll="{ y: 'calc(100vh - 390px)', x: '100%' }"
        :rowKey="record => record.id"
        tableLayout="fixed"
      >
        <a-table-column
          key="reportingId"
          title="报备ID"
          data-index="reportingId"
          width="15%"
        />

        <a-table-column
          key="type"
          title="报备类型"
          data-index="type"
          width="10%"
        >
          <template slot-scope="text, record">
            <span>
              <!-- {{ record.type == 1 ? '签名' : record.type == 2 ? '联系电话' : '引流域名' }} -->
              {{judgeType(record.type)}}
            </span>
          </template>
        </a-table-column>

        <a-table-column
          key="content"
          title="报备内容"
          data-index="content"
          width="37%"
        />

        <a-table-column
          key="status"
          title="报备状态"
          data-index="status"
          width="10%"
        >
          <template slot-scope="text, record">
            <span>
              {{ record.status == 1 ? '已提交' : record.status == 2 ? '有效' : '无效' }}
            </span>
          </template>
        </a-table-column>

        <a-table-column
          key="createTime"
          title="创建时间"
          data-index="createTime"
          width="15%"
        />

        <a-table-column
          key="shareStatus"
          title="是否共享"
          data-index="shareStatus"
          width="8%"
        >
          <template slot-scope="text, record">
            <a-switch
              :checked="record.shareStatus == 2"
              @change="checked => changeShare1(checked, record)"
            />
          </template>
        </a-table-column>

        <a-table-column
          key="isDelete"
          title="操作"
          width="5%"
        >
          <template slot-scope="text, record">
            <span
              @click="deleteTplItem(record.id)"
              style="color:#79889B;cursor:pointer"
            >
              删除
            </span>
          </template>
        </a-table-column>
      </a-table>

      <div class="pagination-table">
          <a-pagination
              class="pagination"
              show-size-changer
              :default-current="1"
              :total="total"
              @change="pageChange"
              @showSizeChange="onShowSizeChange"
          />
      </div>
    </div>
    <a-modal :centered='true' :maskClosable='false' v-model.trim="reportSignModal" title="报备签名" footer='' width='560px'>
      <div class="record-modal modal-public">
        <a-divider style="margin:0 0 12px 0;" type="horizontal" />
        <div style="display: flex;">
          <span style="float: left;margin-top:12px;width:75px;color:rgba(18, 18, 18, 1);font-size:14px;">输入签名：</span>
          <a-input v-model="signContent" style="flex:1" placeholder="请输入" />
        </div>
        <div style="display: flex;margin-top:16px;">
          <span style="float: left;width:75px;color:rgba(18, 18, 18, 1);font-size:14px;">短信内容：</span>
          <a-textarea v-model="msgContent" placeholder="请输入" style="height: 180px;resize: none;flex: 1;" />
        </div>
        <div style="display: flex;margin-top:16px;">
          <span style="float: left;width:75px;color:rgba(18, 18, 18, 1);font-size:14px;">共享：</span>
          <a-switch v-model="signShare" />`
          <!-- <a-switch
            :checked="signShare == 2"
            @change="checked => changeShare2(checked)"
          /> -->
        </div>
        <!-- <div style="margin-top:16px;">
          <span @click="goSignLink" style="display: inline-block;width:165px;height:32px;line-height: 32px;text-align: center;cursor: pointer;background:#fff;border-radius: 4px;background: rgba(24, 144, 255, 1);color:#fff;">点击进入签名报备链接</span>
        </div> -->
        <a-divider class="divider2" type="horizontal" />
        <div class="btn-group">
          <a-button type="primary" ghost @click="cancelReportSign">取消</a-button>
          <a-button v-if="!ifShowStep1" type="primary" @click="sureReportSign">确定</a-button>
          <a-button v-if="ifShowStep1" type="primary" @click="nextStep1">下一步</a-button>
        </div>
      </div>
    </a-modal>
    <a-modal :centered='true' :maskClosable='false' v-model.trim="reportDomainModal" title="报备域名【仅发送移动】" footer='' width='560px'>
      <div class="record-modal modal-public">
        <a-divider style="margin:0 0 12px 0;" type="horizontal" />
        <div style="display: flex;">
          <span style="float: left;margin-top:6px;width:75px;color:rgba(18, 18, 18, 1);font-size:14px;">选择签名：</span>
          <div style="flex:1">
            <div>
              <a-radio-group style="margin-top:6px;" v-model="msgTplSign" @change="changeShareType($event)">
                <a-radio :value="1">
                  我的
                </a-radio>
                <a-radio :value="2">
                  共享
                </a-radio>
              </a-radio-group>
              <span @click="reportSign()" style="display: inline-block;width:128px;height:32px;line-height: 32px;text-align: center;cursor: pointer;background:#fff;border-radius: 4px;background: rgba(66, 223, 228, 1);color:#fff;float: right;">没有签名，去报备</span>
            </div>
            <a-select placeholder="请选择" style="width: 100%;margin-top:8px;margin-right:60px;" v-model="signValue">
              <a-select-option :value="item.id" v-for="(item,index) in reportingManagement" :key="index">
                {{item.content}} 
              </a-select-option>
            </a-select>
          </div>
        </div>
        <div style="display: flex;margin-top:16px;">
          <span style="float: left;margin-top:12px;width:75px;color:rgba(18, 18, 18, 1);font-size:14px;">输入域名：</span>
          <a-input style="flex:1" placeholder="请输入" v-model="signContent" />
        </div>
        <div style="display: flex;margin-top:16px;">
          <span style="float: left;width:75px;color:rgba(18, 18, 18, 1);font-size:14px;">共享：</span>
          <a-switch v-model="signShare" />
          <!-- <span style="color:rgba(121, 136, 155, 1);font-size:14px;margin-left:8px;">文本</span> -->
        </div>
        <!-- <div style="margin-top:16px;">
          <span @click="goSignLink" style="display: inline-block;width:165px;height:32px;line-height: 32px;text-align: center;cursor: pointer;background:#fff;border-radius: 4px;background: rgba(24, 144, 255, 1);color:#fff;">点击进入报备域名链接</span>
        </div> -->
        <a-divider class="divider2" type="horizontal" />
        <div class="btn-group">
          <a-button type="primary" ghost @click="cancelDomain">取消</a-button>
          <a-button v-if="!ifShowStep2" type="primary" @click="sureDomain">确定</a-button>
          <a-button v-if="ifShowStep2" type="primary" @click="nextStep2">下一步</a-button>
        </div>
      </div>
    </a-modal>
    <a-modal :centered='true' :maskClosable='false' v-model.trim="reportPhoneModal" title="报备联系电话【仅发送移动 】" footer='' width='560px'>
      <div class="record-modal modal-public">
        <a-divider style="margin:0 0 12px 0;" type="horizontal" />
        <div style="display: flex;">
          <span style="float: left;margin-top:6px;width:75px;color:rgba(18, 18, 18, 1);font-size:14px;">选择签名：</span>
          <div style="flex:1">
            <div>
              <a-radio-group style="margin-top:6px;" v-model="msgTplSign" @change="changeShareType($event)">
                <a-radio :value="1">
                  我的
                </a-radio>
                <a-radio :value="2">
                  共享
                </a-radio>
              </a-radio-group>
              <span @click="reportSign()" style="display: inline-block;width:128px;height:32px;line-height: 32px;text-align: center;cursor: pointer;background:#fff;border-radius: 4px;background: rgba(66, 223, 228, 1);color:#fff;float: right;">没有签名，去报备</span>
            </div>
            <a-select placeholder="请选择" style="width: 100%;margin-top:8px;margin-right:60px;" v-model="signValue">
              <a-select-option :value="item.id" v-for="(item,index) in reportingManagement" :key="index">
                {{item.content}} 
              </a-select-option>
            </a-select>
          </div>
        </div>
        <div style="display: flex;margin-top:16px;">
          <span style="float: left;margin-top:12px;width:75px;color:rgba(18, 18, 18, 1);font-size:14px;">输入号码：</span>
          <a-input style="flex:1" placeholder="请输入" v-model="signContent"/>
        </div>
        <div style="display: flex;margin-top:16px;">
          <span style="float: left;width:75px;color:rgba(18, 18, 18, 1);font-size:14px;">共享：</span>
          <a-switch v-model="signShare" />
        </div>
        <!-- <div style="margin-top:16px;">
          <span @click="goSignLink" style="display: inline-block;width:165px;height:32px;line-height: 32px;text-align: center;cursor: pointer;background:#fff;border-radius: 4px;background: rgba(24, 144, 255, 1);color:#fff;">点击进入报备号码链接</span>
        </div> -->
        <a-divider class="divider2" type="horizontal" />
        <div class="btn-group">
          <a-button type="primary" ghost @click="cancelPhone">取消</a-button>
          <a-button v-if="!ifShowStep3"  type="primary" @click="surePhone">确定</a-button>
          <a-button v-if="ifShowStep3" type="primary" @click="nextStep3">下一步</a-button>
        </div>
      </div>
    </a-modal>
    <a-modal
      v-model="step1Bool"
      :centered="true"
      :maskClosable="false"
      :footer="null"
      width="1200px"
      destroyOnClose   
    >
      <div style="position:relative">
        <iframe
          :src="iframeUrl1"
          frameborder="0"
          width="100%"
          height="720"
        ></iframe>
        <div style="position:absolute;height:65px;background:#f7f8fa;width:100%;left:0;bottom:0"></div>
      </div>
    </a-modal>
    <a-modal
      v-model="step2Bool"
      :centered="true"
      :maskClosable="false"
      :footer="null"
      width="1200px"
      destroyOnClose   
    >
      <div style="position:relative">
        <iframe
          :src="iframeUrl2"
          frameborder="0"
          width="100%"
          height="720"
        ></iframe>
        <div style="position:absolute;height:65px;background:#f7f8fa;width:100%;left:0;bottom:0"></div>
      </div>
    </a-modal>
    <a-modal
      v-model="step3Bool"
      :centered="true"
      :maskClosable="false"
      :footer="null"
      width="1200px"
      destroyOnClose   
    >
    <div style="position:relative">
        <iframe
          :src="iframeUrl3"
          frameborder="0"
          width="100%"
          height="720"
        ></iframe>
        <div style="position:absolute;height:65px;background:#f7f8fa;width:100%;left:0;bottom:0"></div>
      </div>
    </a-modal>
    <a-modal :centered='true' :maskClosable='false' v-model.trim="deleteBool" footer='' width='480px'>
      <div class="delete-modal modal-public">
          <div class="sure-off-bind">
              <a-icon type="warning" />
              <span>您确定要删除该报备记录吗？</span>
          </div>
          <div class="tip">删除后，无法恢复</div>
          <a-divider class="divider2" type="horizontal" />
          <div class="btn-group">
              <a-button type="primary" ghost @click="cancelDelete">取消</a-button>
              <a-button type="primary" @click="sureDelete">确定</a-button>
          </div>
      </div>
    </a-modal>
  </div>
</template>

<script> 
export default {
  name: 'ReportingManagement',
  data() {
    return {
      ifShowLoading: false,
      total: 0,
      sendMsgRecord: [],
      currentPage: 1,
      pageSize: 10,
      reportSignModal: false,
      reportDomainModal: false,
      reportPhoneModal: false,
      signContent: '',
      msgContent: '',
      signShare: false,
      signDomainShare: 1,
      domainShare: false,
      domainSignSelected: undefined,
      domainContent: '',
      phoneSign: 1,
      phoneShare: false,
      phoneSelected: undefined,
      phoneContent: '',
      reportShare: 1,
      reportType: 0,
      deleteBool: false,
      currentTplId: '',
      code: '',
      reportingUrl: '',
      abbreviation: '',
      reportingManagement: [],
      signValue: undefined,
      msgTplSign: 1,
      ifShowStep1: true,
      step1Bool: false,
      iframeUrl1: '',
      ifShowStep2: true,
      step2Bool: false,
      iframeUrl2: '',
      ifShowStep3: true,
      step3Bool: false,
      iframeUrl3: '',
    }
  },
  methods: {
    pageChange(current, pageSize) {
      this.currentPage = current
      this.pageSize = pageSize
      this.queryReportList()
    },
    onShowSizeChange(current, pageSize) {
      this.currentPage = current
      this.pageSize = pageSize
      this.queryReportList()
    },
    changeSelect(e) {
      this.currentPage = 1
      this.reportShare = e.target.value
      this.queryReportList()
    },
    changeReportType(e) {
      this.currentPage = 1
      this.reportType = e.target.value
      this.queryReportList()
    },
    changeShare1(checked, record) {
      // this.record.shareStatus = checked ? 1 : 2
      this.axios.post('/api/reportingManagement/updateShareStatus', {
        id: record.id,
        shareStatus: checked ? 2 : 1
      })
      .then(response=> {
        if(response.data.code == 0){
          this.queryReportList()
        }else{
          this.$message.error(response.data.userTip);
        }
      })
      .catch(error=> {
        console.log(error);
      });
    },
    reportSign() {
      this.reportPhoneModal = false
      this.reportDomainModal = false
      this.signContent = ''
      this.msgContent = ''
      this.signShare = false
      this.signValue = undefined
      this.reportSignModal = true
      this.ifShowStep1 = true,
      this.step1Bool = false,
      this.iframeUrl1 = ''
      this.queryReportingUrlList(1)
    },
    reportDomainName() {
      this.signDomainShare = 1
      this.msgTplSign = 1
      this.signValue = undefined
      this.reportingManagement = []
      this.domainShare = false
      this.domainSignSelected = undefined
      this.domainContent = ''
      this.signContent = ''
      this.msgContent = ''
      this.signShare = false
      this.reportDomainModal = true
      this.ifShowStep2 = true,
      this.step2Bool = false,
      this.iframeUrl2 = ''
      this.queryReportingUrlList(3)
      this.querySelectList()
    },
    reportPhone() {
      this.phoneSign = 1
      this.msgTplSign = 1
      this.reportingManagement = []
      this.signValue = undefined
      this.phoneShare = false
      this.phoneSelected = undefined
      this.phoneContent = ''
      this.signContent = ''
      this.msgContent = ''
      this.signShare = false
      this.reportPhoneModal = true
      this.ifShowStep3 = true,
      this.step3Bool = false,
      this.iframeUrl3 = ''
      this.queryReportingUrlList(2)
      this.querySelectList()
    },
    cancelReportSign() {
      this.reportSignModal = false
    },
    sureReportSign() {
      this.reportSignModal = false
      this.addSign(1)
    },
    // changeShare2(checked) {
    //   console.log(`a-switch to ${checked}`);
    // },
    cancelDomain() {
      this.reportDomainModal = false
    },
    sureDomain() {
      this.reportDomainModal = false
      this.addSign(3)
    },
    cancelPhone() {
      this.reportPhoneModal = false
    },
    surePhone() {
      this.reportPhoneModal = false
      this.addSign(2)
    },
    goSignLink() {
      window.open(this.reportingUrl+this.abbreviation+'_'+this.code+'_'+this.getNowTimeStr(), '_blank');
    },
    queryReportList() {
      this.axios(
        {
          method:'get',
          url:'/api/reportingManagement/list', 
          params: {
            current: this.currentPage,
            size: this.pageSize,
            shareStatus: this.reportShare,
            type: this.reportType,
          }
        }
      )
      .then(response=> {
        if(response.data.code == 0){
          this.sendMsgRecord = response.data.data.records
          // console.log(this.sendMsgRecord)
          this.total = response.data.data.total
        }else{
          this.$message.error(response.data.userTip);
        }
      })
      .catch(error=> {
          console.log(error)
      })
    },
    deleteTplItem(id) {
      this.currentTplId = id
      this.deleteBool = true
    },
    cancelDelete() {
      this.deleteBool = false
    },
    sureDelete() {
      this.deleteBool = false
      this.axios.post('/api/reportingManagement/delete', {
        id: this.currentTplId,
      })
      .then(response=> {
        if(response.data.code == 0){
          this.currentPage = 1
          this.queryReportList()
        }else{
          this.$message.error(response.data.userTip);
        }
      })
      .catch(error=> {
        console.log(error);
      });
    },
    changeShare2(checked) {
      // console.log(checked)
      this.signShare = checked ? 2 : 1
    },
    queryReportingUrlList(type) {
      this.axios(
        {
          method:'get',
          url:'/api/reportingManagement/reportingUrlList', 
          params: {
            type: type
          }
        }
      )
      .then(response=> {
        if(response.data.code == 0){
          // console.log(response.data.data)
          this.reportingUrl = response.data.data[0]['reportingUrl']
          this.abbreviation = response.data.data[0]['abbreviation']
        }else{
          this.$message.error(response.data.userTip);
        }
      })
      .catch(error=> {
          console.log(error)
      })
    },
    queryLoginInfo() {
      this.axios(
        {
          method:'get',
          url:'/api/user/loginInfo', 
        }
      )
      .then(response=> {
        if(response.data.code == 0){
          this.code = response.data.data.code
        }else{
          this.$message.error(response.data.userTip);
        }
      })
      .catch(error=> {
          console.log(error)
      })
    },
    getNowTimeStr() {
      const now = new Date()

      const MM = String(now.getMonth() + 1).padStart(2, '0')
      const DD = String(now.getDate()).padStart(2, '0')
      const hh = String(now.getHours()).padStart(2, '0')
      const mm = String(now.getMinutes()).padStart(2, '0')
      const ss = String(now.getSeconds()).padStart(2, '0')

      return MM + DD + hh + mm + ss
    },
    querySelectList() {
      this.axios(
        {
          method:'get',
          url:'/api/reportingManagement/selectList', 
          params: {
            shareStatus: this.msgTplSign,
            type: 1,
          }
        }
      )
      .then(response=> {
        if(response.data.code == 0){
          // console.log(response.data.data)
          this.reportingManagement = response.data.data
        }else{
          this.$message.error(response.data.userTip);
        }
      })
      .catch(error=> {
          console.log(error)
      })
    },
    changeShareType(e) {
      this.msgTplSign = e.target.value
      this.querySelectList()
    },
    addSign(type) {
      this.axios.post('/api/reportingManagement/saveReporting', {
        type: type,
        reportingId: this.abbreviation+'_'+this.code+'_'+this.getNowTimeStr(),
        content: this.signContent,
        shareStatus: this.signShare?2:1,
        smsContent: this.msgContent,
        reportingSignId: this.signValue,
      })
      .then(response=> {
        if(response.data.code == 0){
          // console.log(response.data.data)
          this.currentPage = 1
          this.pageSize = 10
          this.reportShare = 1
          this.reportType = 0
          this.queryReportList()
        }else{
          this.$message.error(response.data.userTip);
        }
      })
      .catch(error=> {
        console.log(error);
      });
    },
    nextStep1() {
      this.ifShowStep1 = false
      this.iframeUrl1 = this.reportingUrl+this.abbreviation+'_'+this.code+'_'+this.getNowTimeStr()
      this.step1Bool = true
    },
    nextStep2() {
      this.ifShowStep2 = false
      this.iframeUrl2 = this.reportingUrl+this.abbreviation+'_'+this.code+'_'+this.getNowTimeStr()
      this.step2Bool = true
    },
    nextStep3() {
      this.ifShowStep3 = false
      this.iframeUrl3 = this.reportingUrl+this.abbreviation+'_'+this.code+'_'+this.getNowTimeStr()
      this.step3Bool = true
    },
    judgeType(type) {
      const map = {
        1: '签名',
        3: '引流域名_移动',
        2: '联系电话_移动',
        4: '引流域名_联通',
        5: '联系电话_联通',
        6: '引流域名_电信',
        7: '联系电话_电信'
      }
      return map[type] || '未知类型'
    }
  },
  mounted: function() {
    this.sessionData('set','contentNavItem','ReportingManagement');
    this.queryReportList()
    this.queryLoginInfo()
    
  }
}
</script>

<style lang="less">
  .pagination-table{
    padding-top: 24px;
    text-align: right;
  }
  .modal-public{
    .divider1{
        margin: 0px 0 24px 0;
    }
    .divider2{
        margin: 24px 0 12px;
    }
    .btn-group{
      float: right;
      button{
          // width: 64px;
          height: 32px;
          font-size: 14px;
      }
      button:nth-child(1){
          margin-right: 16px;
      }
    }
    .btn-group2{
      float: right;
      button{
          // width: 64px;
          height: 32px;
          font-size: 14px;
      }
      button:nth-child(1){
          background: #fff;
          color: rgba(121, 136, 155, 0.7);
          border: 1px solid rgba(121, 136, 155, 0.5);
          margin-right: 16px;
      }
      button:nth-child(1):hover{
          background: rgba(121, 136, 155, 0.08);
      }
    }
  }
  .record-modal{
    padding-bottom: 44px;
    .changed-name{
      color: rgba(153, 153, 153, 1);
      font-size: 14px;
    }
    input{
      margin-top: 8px;
    }
  }
  .delete-modal{
    padding-top: 24px;
    padding-bottom: 44px;
    .sure-off-bind{
        i{
            color: rgba(255, 170, 0, 1);
            font-size: 24px;
        }
        span{
            color: rgba(18, 18, 18, 1);
            font-size: 20px;
            margin-left: 24px;
        }
    }
    .tip{
        color: rgba(80, 80, 80, 1);
        padding-left: 50px;
        margin: 24px 0;
    }
  }
</style>
